import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Avatar } from '@progress/kendo-react-layout';
import { ITicketProps } from '../../types/Ticket/ITicket';
import { Link } from 'react-router-dom';
import './TicketCard.scss';
import AutoLinker from './TicketDetails/Sections/Tools/AutoLinker';
import * as svg from '@progress/kendo-svg-icons';
import ReactTimeago from 'react-timeago';
import { Button } from '@progress/kendo-react-buttons';
import { RevUserContextType, RevUserContext } from '../../context/UserContext';
import { isDate } from 'lodash';

interface TicketCardProps extends ITicketProps {

}

const TicketCard: React.FC<TicketCardProps> = (ticket) => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext);
    const [more, setMore] = React.useState(false);
    return (
        <div className='ticket-card'>
            <div className={ticket.StateCssClass}>
                <Card>
                    <CardHeader >
                        <Link className='nav-link ticket-link' to={`/ticket/${ticket.ID}`}>
                            <div className='header'>
                                {profile?.Features?.Profile_Action_Images && <ProfileImaage imageUrl={ticket.Contact_Profile_Image} name={ticket.Contact_Name}></ProfileImaage>}
                                <div className='details'>
                                    <div className='row-1'>
                                        <h4 className='text-info'>{ticket.Contact_Name}</h4>
                                        <Button size='medium'>{ticket.ID}</Button>
                                    </div>
                                    <div className='d-block'>{ticket.Company_Name} ({ticket.Project_Name})</div>
                                </div>
                                <div className={ticket.StateCssClass + ' shim'}>
                                </div>
                            </div>
                        </Link>

                    </CardHeader>
                    <CardBody>

                        <div className='lead truncate-3-lines'><AutoLinker text={ticket.Call_Desc}></AutoLinker> </div>
                    </CardBody>
                    <CardFooter><div className='row-nope text-muted footer'>

                        {/* <div className='col-6'><Button svgIcon={svg.chevronLeftIcon}></Button> </div> */}
                        {more ?
                            <div className="row" id={`collapseDetails_${ticket.ID}`}>
                                <div className="col-6">Created:</div><div className="col-6">{new Date(ticket.Open_Dt + 'Z').toLocaleDateString()} {new Date(ticket.Open_Dt + 'Z').toLocaleTimeString()}</div>
                                <div className="col-6">Status:</div><div className="col-6">{ticket.Call_Status}</div>
                                <div className="col-6">Priority:</div><div className="col-6">{ticket.Priority_Level}</div>
                                {ticket.Call_Type_Path && <><div className="col-6">Type:</div><div className="col-6">{ticket.Call_Type_Path}</div></>}
                                {new Date(ticket.Due_Dt + 'Z').toString() !== 'Invalid Date' && <><div className="col-6">Due:</div><div className="col-6"><div>{new Date(ticket.Due_Dt + 'Z').toLocaleDateString()} {new Date(ticket.Due_Dt + 'Z').toLocaleTimeString()}</div></div></>}

                            </div>
                            : <div>Created: <ReactTimeago date={new Date(ticket.Open_Dt + 'Z')}></ReactTimeago> </div>}
                        <div> <Button svgIcon={more ? svg.chevronDownIcon : svg.chevronLeftIcon} fillMode='flat' onClick={() => setMore((m) => !m)}></Button></div>
                    </div></CardFooter>
                </Card>
            </div>
        </div >
    );
};

const ProfileImaage: React.FC<{ imageUrl: string, name?: string }> = ({ imageUrl, name }) => {
    const initials = name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : '';
    return (
        <span className="profile-image">
            {!imageUrl ?
                <Avatar type="image" size='medium' >
                    {initials && <div className='initials'>{initials}</div>}
                </Avatar>
                :
                <Avatar type="image" size='medium' className='image'>
                    <img src={imageUrl} alt="Profile" />
                </Avatar>}
        </span>
    );
}

export default TicketCard;
